import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGetProductList2 } from "../api/queries/productQueries";

export const useSearchProductPage = ({ type }: { type: string }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const itemsPerPage = 12;

  // --- State for search filters & pagination ---
  const [search, setSearch] = useState({
    city: searchParams.get("city") || "",
    category: searchParams.get("category") || "",
    subCategory: searchParams.get("subCategory") || "",
    keyword: searchParams.get("keyword") || "",
    commonSort: searchParams.get("commonSort") || "",
    type,
    pageSize: itemsPerPage,
    pageIndex: 0, 
  });


  const { data, isLoading } = useGetProductList2(search);

  const [dataProduct, setDataProduct] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (!data) return;

    const products = data.data || [];
    setDataProduct(products);
    setTotalPages(data.totalPages || 1);
  }, [data]);


  const handlePageChange = (newPage: number) => {
    setSearch((prev) => ({
      ...prev,
      pageIndex: newPage,
    }));
  };

  // --- Category filter handler ---
  const onChooseCate = (cateId: number) => {
    if (cateId === 0) {
      setSearch((prev) => ({
        ...prev,
        category: "",
        pageIndex: 0,
      }));
      return;
    }
    else {
      setSearch((prev) => ({
        ...prev,
        category: cateId.toString(),
        pageIndex: 0,
      }));
    }
  };

  // --- Sort change handler ---
  const onChooseCommonSort = (commonSort: string) => {
    setSearch((prev) => ({
      ...prev,
      commonSort,
      pageIndex: 0, 
    }));
  };

  return {
    type,
    dataProduct,
    totalPages,
    currentPage: search.pageIndex,
    isLoading,
    search,
    setSearch,
    handlePageChange,
    onChooseCate,
    onChooseCommonSort,
  };
};

export type TUseSearchProductPageResponse = ReturnType<
  typeof useSearchProductPage
>;
